import { useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import Empty from '../../../assets/EmptyUsers.png';
import EmptyState from '../../orders/components/EmptyState';
import { ListCards } from './ListCard';
import { ListTable } from './ListTable';

function UserList({
  isLoadingOrFetching,
  onLoadMore,
  data,
  onEdit,
  onResend,
  onDelete,
}) {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const hasNextPage =
    data?.pagination?.pageNumber < data?.pagination?.totalPages;
  const loading = isLoadingOrFetching;
  const showSkeleton = hasNextPage || isLoadingOrFetching;

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore,
  });

  return (
    <>
      {!smallScreen && (
        <ListTable
          data={data}
          showSkeleton={showSkeleton}
          forwardedRef={sentryRef}
          onEdit={onEdit}
          onResend={onResend}
          onDelete={onDelete}
        />
      )}
      {smallScreen && (
        <ListCards
          data={data}
          showSkeleton={showSkeleton}
          forwardedRef={sentryRef}
          onEdit={onEdit}
          onResend={onResend}
          onDelete={onDelete}
        />
      )}
    </>
  );
}

export default function UsersTable({
  onLoadMore,
  data,
  isLoadingOrFetching,
  onEdit,
  onResend,
  onDelete,
}) {
  const { t } = useTranslation('users');

  return (
    <>
      <UserList
        onLoadMore={onLoadMore}
        data={data}
        onEdit={onEdit}
        isLoadingOrFetching={isLoadingOrFetching}
        onResend={onResend}
        onDelete={onDelete}
      />
      <EmptyState
        show={data && !data.users.length}
        img={Empty}
        title={t('emptyTitle')}
        subtitle={t('emptySubtitle')}
      />
    </>
  );
}
